import Paper from "../../../../../src/components/paper/Paper";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Paper,
  Playground,
  Props,
  React
};